import { FC } from "react"
import styles from '../../styles/index.module.scss'
import { UserCard } from "./UserCard"

const DashboardBusinessControlsPluginView: FC<IGridProps> = () => {
    return <>
        <div className={styles.wrapperCards}>
           <UserCard/>
        </div>
            
    </>
}

export default DashboardBusinessControlsPluginView